import React from "react";
import { useMsal } from "@azure/msal-react";
import { Button, ListItemText } from "@mui/material";
import LogoutIcon from '@mui/icons-material/Logout';

export const LogoutButton = ({ asMenuItem = false }) => {
    const { instance } = useMsal();

    const handleLogout = (logoutType) => {
        if (logoutType === "popup") {
            instance.logoutPopup({
                postLogoutRedirectUri: "/",
                mainWindowRedirectUri: "/"
            });
        } else if (logoutType === "redirect") {
            instance.logoutRedirect({
                postLogoutRedirectUri: "/",
            });
        }
    }

    if (asMenuItem) {
        return (
            <ListItemText
                onClick={() => handleLogout("popup")}
                sx={{ cursor: 'pointer' }}
            >
                Sign Out
            </ListItemText>
        );
    }

    return (
        <Button
            variant="outlined"
            color="secondary"
            startIcon={<LogoutIcon />}
            onClick={() => handleLogout("popup")}
        >
            Sign Out
        </Button>
    );
};
